// extracted by mini-css-extract-plugin
export default {"App__Main":"App_App__Main__WQ-Am"};